import { PopupDialog } from "../lib/popup-dialog.ts";

interface MarketSelectorRefs {
  overlay?: HTMLElement;

  dialog?: HTMLElement;

  close?: HTMLButtonElement;

  radios?: HTMLInputElement[];
}

class MarketSelector extends PopupDialog<MarketSelectorRefs> {
  get inertId(): string {
    return "market-selector";
  }

  getFocusTarget(): HTMLElement | null {
    const checked = (this.refs.radios ?? []).find((radio) => radio.checked);
    if (checked) return checked;
    return this.refs.dialog;
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.refs.overlay.addEventListener("click", this.#handleClose, { signal: this.signal });
    this.refs.close?.addEventListener("click", this.#handleClose, { signal: this.signal });
    document.addEventListener("click", this.#handleTriggerClick, { signal: this.signal });

    if (window.Shopify?.designMode) {
      document.addEventListener("shopify:section:select", this.#handleSectionSelect, {
        signal: this.signal,
      });
      document.addEventListener("shopify:section:deselect", this.#handleSectionDeselect, {
        signal: this.signal,
      });
    }
  }

  #handleTriggerClick = (event: MouseEvent): void => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest("[data-market-selector-trigger]")) return;
    event.preventDefault();
    this.open();
  };

  #handleSectionSelect = (event: Event): void => {
    if (event.target instanceof Element && event.target.contains(this)) {
      this.open();
    }
  };

  #handleSectionDeselect = (event: Event): void => {
    if (event.target instanceof Element && event.target.contains(this)) {
      this.close();
    }
  };

  #handleClose = (): void => {
    this.close();
  };
}

if (!customElements.get("market-selector")) {
  customElements.define("market-selector", MarketSelector);
}
